<template>
  <div class="friends">
    <AppTable
      v-if="tableData.length"
      :fields="tableFields"
      :items="tableData"
    >
      <template #name="data">
        <BaseLink :href="`/user/${data.id}`">
          {{ data.name }}
        </BaseLink>
      </template>
    </AppTable>

    <p v-else class="h3">Список друзей пуст.</p>
  </div>
</template>

<script>
import AppTable from '@/components/AppTable'
import BaseLink from '@/components/Base/BaseLink'

export default {
  name: 'AppFriends',
  components: {
    BaseLink,
    AppTable
  },
  data () {
    return {
      tableFields: [
        { key: 'name', label: 'Имя', sortable: true, slot: true },
        { key: 'surname', label: 'Фамилия', sortable: true },
        { key: 'login', label: 'Логин', sortable: true },
        { key: 'mail', label: 'Почта', sortable: true },
        { key: 'date', label: 'Дата создания', sortable: true }
      ],
      tableData: []
    }
  },
  created () {
    this.fetchUsers()
  },
  methods: {
    async fetchUsers () {
      try {
        const { data } = await this.$api.user.friends(this.$route.params.id)
        const list = data?.list ?? []

        this.tableData = list.map(item => {
          const id = item?.id ?? ''
          const name = item?.name ?? ''
          const surname = item?.surname ?? ''
          const login = item?.username ?? ''
          const mail = item?.email ?? ''
          const date = item?.createdAt ?? ''

          return {
            id,
            name,
            surname,
            login,
            mail,
            date
          }
        })
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.friends {}
</style>
